const demoDate = (dayOffset, hour = 9, minute = 0) => {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + dayOffset);
  date.setHours(hour, minute, 0, 0);
  return date.toISOString();
};

export const AI_SUGGESTION_COUNT = 2;

/**
 * Builds the mocked Glovely AI task suggestions in the same shape used by
 * regular clienteling task cards.
 * @param {Function} t Translation function from vue-i18n.
 * @returns {Array<Object>} Task-like AI suggestion records.
 */
export const buildTaskAISuggestions = t => [
  {
    id: 'ai_task_001',
    title: t('TASKS.AI_SUGGESTIONS.ITEMS.PURPLE_RINGS.TITLE'),
    description: `${t('TASKS.AI_SUGGESTIONS.ITEMS.PURPLE_RINGS.REASON_PREFIX')}${t('TASKS.AI_SUGGESTIONS.ITEMS.PURPLE_RINGS.SOURCE_LABEL')}${t('TASKS.AI_SUGGESTIONS.ITEMS.PURPLE_RINGS.REASON_SUFFIX')}`,
    status: 'todo',
    priority: 'high',
    type: 'follow_up',
    typeLabel: t('TASKS.TYPE.FOLLOW_UP'),
    dueDate: demoDate(7, 10),
    dueTimePresent: false,
    linkedContactId: 'cus_001',
    linkedProjectId: 'project_001',
    contactName: 'Sophie Martin',
    projectTitle: 'Projet bague de fiançailles',
  },
  {
    id: 'ai_task_002',
    title: t('TASKS.AI_SUGGESTIONS.ITEMS.SIZE_CHECK.TITLE'),
    description: `${t('TASKS.AI_SUGGESTIONS.ITEMS.SIZE_CHECK.REASON_PREFIX')}${t('TASKS.AI_SUGGESTIONS.ITEMS.SIZE_CHECK.SOURCE_LABEL')}${t('TASKS.AI_SUGGESTIONS.ITEMS.SIZE_CHECK.REASON_SUFFIX')}`,
    status: 'todo',
    priority: 'medium',
    type: 'stock_check',
    typeLabel: t('TASKS.TYPE.STOCK_CHECK'),
    dueDate: demoDate(0, 16),
    dueTimePresent: false,
    linkedContactId: 'cus_002',
    linkedProjectId: 'project_003',
    contactName: 'Monsieur Laurent',
    projectTitle: 'Bracelets favoris',
  },
];
